module.exports = global["$"] = require("-!C:\\WREPO\\Web.Projects\\Web.Rusmebel\\frontend\\node_modules\\expose-loader\\index.js?jQuery!C:\\WREPO\\Web.Projects\\Web.Rusmebel\\frontend\\node_modules\\source-map-loader\\index.js!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 3
// module chunks = 0